import { useSellerHomescreenContext } from '../../../SellerHomescreenContext';
import { Stack } from '@mui/system';
import CustomChip from '../../../../../../../components/custom-chip/CustomChip';
import { mapLanguage } from 'tdc-web-backend/enums/enums';
import { EnumLanguage } from 'tdc-web-backend/enums/enums';
import { Dispatch, SetStateAction } from 'react';
import CompanyWorkingLanguagesEditModal from '../edit/CompanyWorkingLanguagesEditModal';
import { truncate } from '../../../../../../../utils/helpers';

interface CompanyWorkingLanguagesProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyWorkingLanguages = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyWorkingLanguagesProps) => {
  const { companyData, chipLabelTruncateValue } = useSellerHomescreenContext();

  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {companyData?.languages?.map((language: EnumLanguage) => (
        <CustomChip
          key={language}
          tooltipTitle={mapLanguage.get(language)}
          label={
            language &&
            truncate(mapLanguage.get(language) as string, chipLabelTruncateValue as number)
          }
          sx={{ width: 'fit-content', textTransform: 'capitalize' }}
        />
      ))}

      {companyData && isEditModalOpen && (
        <CompanyWorkingLanguagesEditModal
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
        />
      )}
    </Stack>
  );
};

export default CompanyWorkingLanguages;
